export const ONE_BUREAU_COGNIGY_URL_TOKEN =
  'b4a4c650f01c4a4085e589d86451eff96937c93bfeeb1fc1150a8e33829d2082';
export const THREE_BUREAU_COGNIGY_URL_TOKEN =
  '8b02f61de0f973aa20691f6e82700763437bb35b0c35b394a6223cf7e45bc934';
export const CASH_COGNIGY_URL_TOKEN =
  '95f60dc82cc3089601a21b92cdda9d66e791c7036d018f88250a8907eab0974f';
